import { HttpContextToken } from '@angular/common/http';

/** When true, auth interceptor will not show a success toast for this request (not sent to the server). */
export const SKIP_SUCCESS_NOTIFICATION = new HttpContextToken<boolean>(() => false);
